// Centralized data-testid constants used across the app.
// Keeps QA selectors stable and reviewable in one place.

export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  sidebar: "sidebar-root",
  item: (key) => `sidebar-nav-${key}`,
  logo: "sidebar-logo",
};

export const KPI = {
  card: (key) => `kpi-card-${key}`,
};

export const LEDGER = {
  search: "ledger-search-input",
  agencyFilter: "ledger-agency-filter",
  platformFilter: "ledger-platform-filter",
  row: (id) => `ledger-row-${id}`,
  empty: "ledger-empty-state",
};

export const DRAWER = {
  root: "bid-drawer",
  close: "bid-drawer-close",
  backdrop: "bid-drawer-backdrop",
  download: "bid-drawer-download",
  save: "bid-drawer-save",
};

export const AI = {
  tabDetails: "ai-tab-details",
  tabAssistant: "ai-tab-assistant",
  inputCompany: "ai-input-company",
  inputAmount: "ai-input-amount",
  inputNotes: "ai-input-notes",
  generate: "ai-generate-btn",
  spinner: "ai-spinner",
  output: "ai-output",
  copy: "ai-copy-btn",
  clear: "ai-clear-btn",
};

export const SAVED = {
  card: (id) => `saved-card-${id}`,
  remove: (id) => `saved-remove-${id}`,
  empty: "saved-empty-state",
};

export const ALERTS = {
  toggle: (key) => `alerts-toggle-${key}`,
};

export const API_VIEW = {
  copy: "api-copy-btn",
};

// --- Submission flow ---------------------------------------------------------
export const SUBMIT = {
  open: "submit-open-btn",
  modal: "submit-modal",
  inputSignatory: "submit-input-signatory",
  inputEmail: "submit-input-email",
  confirm: "submit-confirm-btn",
  progress: "submit-progress",
  status: "submit-status",
  success: "submit-success",
  receipt: "submit-receipt",
  close: "submit-close-btn",
};

// --- Owner Setup Wizard ------------------------------------------------------
export const WIZ = {
  step: (n) => `wiz-step-${n}`,
  next: "wiz-next-btn",
  back: "wiz-back-btn",
  inputOpenAi: "wiz-input-openai-key",
  selectModel: "wiz-select-model",
  inputStripe: "wiz-input-stripe-key",
  inputFee: "wiz-input-fee",
  inputSupabaseUrl: "wiz-input-supabase-url",
  inputSupabaseKey: "wiz-input-supabase-key",
  rlsToggle: "wiz-rls-toggle",
  scraper: (region) => `wiz-scraper-${region}`,
  initialize: "wiz-initialize-btn",
  deployModal: "wiz-deploy-modal",
  deploySuccess: "wiz-deploy-success",
  deployClose: "wiz-deploy-close",
};

// --- Auth gateway ------------------------------------------------------------
export const AUTH = {
  gateway: "auth-gateway",
  tabSignIn: "auth-tab-signin",
  tabSignUp: "auth-tab-signup",
  inputEmail: "auth-input-email",
  inputPassword: "auth-input-password",
  inputCompany: "auth-input-company",
  submit: "auth-submit-btn",
  status: "auth-status",
  logout: "sidebar-logout-btn",
};
